
/* injects from baggage-loader */
require('./style.styl');

import React, {cloneElement, Children} from 'react'
import PropTypes from 'prop-types'
import partial from 'utils/partial'
import isString from 'lodash/isString'
import classnames from 'classnames'
import Loader from 'components/Loader'
import Cell from './Cell'
import Header from './Header'
import Body from './Body'
import Row from './Row'
import RowGroup from './RowGroup'
import RowGroupHeader from './RowGroupHeader'
import Title from 'components/Title'
import {range} from 'lodash'

function Column() { return null }

class Table extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    data: PropTypes.arrayOf(PropTypes.object),
    groupKey: PropTypes.string,
    loading: PropTypes.bool,
    empty: PropTypes.node,
    title: PropTypes.node,
    legend: PropTypes.node,
    onRowOver: PropTypes.func,
    onRowOut: PropTypes.func,
    onRowClick: PropTypes.func,
    rowClassName: PropTypes.string,
    shouldRowUpdate: PropTypes.func,
    hover: PropTypes.bool,
    loadingRows: PropTypes.number
  }

  static defaultProps = {
    shouldRowUpdate: () => true,
    loadingRows: 3
  }

  constructor(props) {
    super(props)
    this.state = {
      collapsedGroups: {}
    }
    this._cachedRows = new WeakMap()
  }

  render() {
    const {legend, className, loading} = this.props

    return (
      <div className={classnames('table', className,
        {
          'is-loading': loading
        })}>
        {this.renderTitle()}
        {legend}

        <div className='table_container'>
          {this.renderHeader()}
          <Body>
            {this.renderBody()}
          </Body>
        </div>
        {this.renderEmpty()}
        {this.renderLoader()}
      </div>
    )
  }

  renderTitle() {
    const {title} = this.props

    return title ? <Title>{title}</Title> : null
  }

  renderHeader() {
    const columns = Children.toArray(this.props.children)
    const haveHeader = columns.some(column => column.props.header)

    if (haveHeader) {
      return (
        <Header>
          {columns.map(this.renderHeaderCell)}
        </Header>
      )
    } else {
      return null
    }
  }

  renderBody() {
    const {data, loading, groupKey, loadingRows} = this.props

    if (loading) return range(loadingRows).map(index => this.renderRow({}, index))
    if (!data || data.length === 0) return null

    return data.map((data, index) => {
      if (data[groupKey]) {
        return this.renderGroup(data, index)
      } else {
        return this.renderRow(data, index)
      }
    })
  }

  renderEmpty() {
    const {data, loading, empty = null} = this.props
    const isDataEmpty = !data || data.length === 0
    if (isDataEmpty && !loading) {
      return <div className='table_empty'>{empty}</div>
    }
  }

  renderLoader() {
    const {loading} = this.props

    return loading ? <Loader /> : null
  }

  renderGroup(data, index) {
    const {children, groupKey} = this.props
    const {color, id: groupId} = data
    const columns = Children.toArray(children)
    const isCollapsed = !!this.state.collapsedGroups[groupId]

    return (
      <RowGroup color={color} key={index} collapsed={isCollapsed}>
        <RowGroupHeader onClick={partial(this.onRowGroupHeaderClick, groupId)}>
          {columns.map((column, index) => {
            return this.renderCell(data, column, index)
          })}
        </RowGroupHeader>
        {!isCollapsed
          ? data[groupKey].map((data, index) => this.renderRow(data, index))
          : null
        }
      </RowGroup>
    )
  }

  renderRow(data, index) {
    const {shouldRowUpdate, hover, rowClassName, onRowClick} = this.props
    const columns = Children.toArray(this.props.children)

    if (!this._cachedRows.has(data) || shouldRowUpdate(data)) {
      this._cachedRows.set(data,
        <Row
          onMouseOver={this.onRowOver}
          onMouseOut={this.onRowOut}
          onClick={onRowClick && this.onRowClick}
          className={rowClassName}
          key={index}
          data={data}
          hover={hover}
        >
          {columns.map((column, index) => {
            return this.renderCell(data, column, index)
          })}
        </Row>
      )
    }
    return this._cachedRows.get(data)
  }

  renderHeaderCell(column, index) {
    const {header = '', width, className} = column.props
    let headerElement = header
    if (isString(header)) {
      headerElement = <Cell className={className}>{header}</Cell>
    }
    return cloneElement(headerElement, {width, key: index})
  }

  renderCell(data, column, index) {
    const {loading} = this.props
    const {cell, width} = column.props
    if (loading) return <Cell width={width} key={index}><div className='table_loading-placeholder' /></Cell>
    return cloneElement(cell(data), {width, key: index})
  }

  onRowOver = data => {
    const {onRowOver} = this.props
    this._cachedRows.delete(data)
    onRowOver && onRowOver(data)
  }

  onRowOut = data => {
    const {onRowOut} = this.props
    this._cachedRows.delete(data)
    onRowOut && onRowOut(data)
  }

  onRowClick = data => {
    const {onRowClick} = this.props
    this._cachedRows.delete(data)
    onRowClick && onRowClick(data)
  }

  onRowGroupHeaderClick = groupId => {
    const {collapsedGroups} = this.state
    this.setState({
      collapsedGroups: {
        ...collapsedGroups,
        [groupId]: !this.state.collapsedGroups[groupId]
      }
    })
  }
}

export {Table, Column, Cell}



// WEBPACK FOOTER //
// ./client/components/Table/index.js